export function buildMenu(menuItems, lang, env, basePath = null, contenutoId, minisiti) {
    if (menuItems && Array.isArray(menuItems)) {
        menuItems = menuItems.filter(el => !el.field_check_superheader).map(item => {
            let baseURL = '';

            if (item.node?.relationships?.parent && (item.node?.relationships?.parent[0]?.name?.toLowerCase() === "aree tematiche" || item.node?.relationships?.parent[0]?.name?.toLowerCase() === "thematic areas")) {
                baseURL = item.node?.relationships?.field_link_menu?.relationships?.field_sottodominio
                    ? minisiti
                        ? minisiti[`MINISITO_${item.node.relationships.field_link_menu.relationships.field_sottodominio.name.toUpperCase().replace(new RegExp("[\\s-]+", "g"), '_')}_URL`]
                        : ''
                    : ''
            } else {

                baseURL = basePath
                    ? basePath
                    : (item.node?.relationships?.field_link_menu?.relationships?.field_sottodominio
                        ? minisiti
                            ? minisiti[`MINISITO_${item.node.relationships.field_link_menu.relationships.field_sottodominio.name.toUpperCase().replace(new RegExp("[\\s-]+", "g"), '_')}_URL`]
                            : ''
                        : '')
            }
            let link = `${baseURL}${lang ? "/" + lang : ''}${item.node.relationships.field_link_menu && item.node.relationships.field_link_menu.fields ? item.node.relationships.field_link_menu.fields.slug : ''}`;
            return {
                id: item.node.drupal_internal__tid,
                link,
                idContenuto: item.node.relationships.field_link_menu ? item.node.relationships.field_link_menu.drupal_internal__nid : null,
                title: item.node.name ? item.node.name : '',
                children: [],
                weight: item.node.weight,
                idParent: item.node?.relationships?.parent?.length ? item.node.relationships.parent[0].drupal_internal__tid : null,
                active: false
            }
        });
        menuItems.forEach((item, index, array) => {
            if (item.idParent) {
                array.find(i => item.idParent === i.id).children.push(array[index]);
            }
        });

        for (var i in menuItems) {
            if (menuItems[i].idContenuto === contenutoId) {
                menuItems[i].active = true;

                const activeMenuItem = (idParent) => {
                    for (var i in menuItems) {
                        if (menuItems[i].id === idParent) {
                            menuItems[i].active = true;
                            break;
                        }
                    }
                    if (menuItems[i].idParent) {
                        activeMenuItem(menuItems[i].idParent);
                    }
                }

                if (menuItems[i].idParent) {
                    activeMenuItem(menuItems[i].idParent);
                }
                break;
            }
        }
        return menuItems.filter(i => i.idParent == null);
    }
    return [];
}

export function formatData(input, dataFormat = false, lang = 'it') {
    if (dataFormat) {
        return input;
    } else {
        const date = new Date(input);

        var options = {year: 'numeric', month: 'long', day: 'numeric'};
        if (lang === 'it') {
            return date.toLocaleDateString("it-IT", options);
        } else {
            return date.toLocaleDateString("en-EN", options);
        }


        /*const year = date.getFullYear();
        let day = date.getDate();
        let month = date.getMonth() + 1;
        day = day < 10 ? "0" + day : day;
        month = month < 10 ? "0" + month : month;
        return [day, month, year].join("/");*/
    }
}

export function getBreadcrumbItems(menuItems, idContenuto, lang, env, elencoId = null, breadcrumbItem = null) {
    let breadcrumbItems = [];
    let element = null;
    const buildBreadcrumb = (idParent) => {
        let parent = menuItems.find(item => item.node.drupal_internal__tid === idParent);
        if (parent.node.name === 'Homepage') {
            return;
        }
        let slug = `/${lang}${parent.node.relationships.field_link_menu && parent.node.relationships.field_link_menu.fields ? parent.node.relationships.field_link_menu.fields.slug : ''}`;
        breadcrumbItems.push({
            name: parent.node.name,
            slug: slug && slug.trim() !== `/${lang}` ? slug : null,
            active: false
        });
        if (parent.node.relationships?.parent?.length)
            buildBreadcrumb(parent.node.relationships.parent[0].drupal_internal__tid);
    };
    if (idContenuto && Array.isArray(menuItems))
        element = menuItems.find(item => item.node.relationships.field_link_menu && item.node.relationships.field_link_menu.drupal_internal__nid === idContenuto);

    if (elencoId && breadcrumbItem && Array.isArray(menuItems) && !element) {
        element = menuItems.find(item => item.node.relationships.field_link_menu && item.node.relationships.field_link_menu.drupal_internal__nid === elencoId);
        if (element) {
            breadcrumbItems.push(breadcrumbItem);

            let slug = `/${lang}${element.node.relationships.field_link_menu && element.node.relationships.field_link_menu.fields ? element.node.relationships.field_link_menu.fields.slug : ''}`;
            breadcrumbItems.push({
                name: element.node.name,
                slug,
                active: false
            });

            if (element.node.relationships?.parent?.length)
                buildBreadcrumb(element.node.relationships.parent[0].drupal_internal__tid);

            breadcrumbItems.push({
                name: "Home",
                slug: `/${lang}`,
                active: false
            });
        }
        return breadcrumbItems.reverse();
    } else if (idContenuto && Array.isArray(menuItems) && element) {
        let slug = `/${lang}${element.node.relationships.field_link_menu && element.node.relationships.field_link_menu.fields ? element.node.relationships.field_link_menu.fields.slug : ''}`;
        breadcrumbItems.push({
            name: element.node.name,
            slug,
            active: true
        });

        if (element.node.relationships?.parent?.length)
            buildBreadcrumb(element.node.relationships.parent[0].drupal_internal__tid);

        breadcrumbItems.push({
            name: "Home",
            slug: `/${lang}`,
            active: false
        });

        return breadcrumbItems.reverse();
    } else if (!element && breadcrumbItem) {
        breadcrumbItems.push(...[{
            name: "Home",
            slug: `/${lang}`,
            active: false
        }, breadcrumbItem]);
        return breadcrumbItems;
    }
    return null;
}

export function getBreadcrumbItemsDaElenco(menuItems, idContenuto, lang, env, elencoId = null, breadcrumbItem = null, portaleUrl) {
    let breadcrumbItems = [];
    let element = null;
    const buildBreadcrumb = (idParent) => {
        let parent = menuItems.find(item => item.node.drupal_internal__tid === idParent);
        if (parent.node.name === 'Homepage') {
            return;
        }
        let slug = `/${lang}${parent.node.relationships.field_link_menu && parent.node.relationships.field_link_menu.fields ? parent.node.relationships.field_link_menu.fields.slug : ''}`;
        breadcrumbItems.push({
            name: parent.node.name,
            slug: slug && slug.trim() !== `/${lang}` ? slug : null,
            active: false
        });
        if (parent.node.relationships?.parent?.length)
            buildBreadcrumb(parent.node.relationships.parent[0].drupal_internal__tid);
    };
    if (idContenuto && Array.isArray(menuItems))
        element = menuItems.find(item => item.node.relationships.field_link_menu && item.node.relationships.field_link_menu.drupal_internal__nid === idContenuto);

    if (elencoId && breadcrumbItem && Array.isArray(menuItems) && !element) {
        element = menuItems.find(item => item.node.relationships.field_link_menu && item.node.relationships.field_link_menu.drupal_internal__nid === elencoId);
        if (element) {
            breadcrumbItems.push(breadcrumbItem);

            let slug = `${portaleUrl}/${lang}${element.node.relationships.field_link_menu && element.node.relationships.field_link_menu.fields ? element.node.relationships.field_link_menu.fields.slug : ''}`;
            breadcrumbItems.push({
                name: element.node.name,
                slug,
                active: false
            });

            if (element.node.relationships?.parent?.length)
                buildBreadcrumb(element.node.relationships.parent[0].drupal_internal__tid);

            breadcrumbItems.push({
                name: "Home",
                slug: `${portaleUrl}/${lang}`,
                active: false
            });
        }
        return breadcrumbItems.reverse();
    } else if (idContenuto && Array.isArray(menuItems) && element) {
        let slug = `/${lang}${element.node.relationships.field_link_menu && element.node.relationships.field_link_menu.fields ? element.node.relationships.field_link_menu.fields.slug : ''}`;
        breadcrumbItems.push({
            name: element.node.name,
            slug,
            active: true
        });

        if (element.node.relationships?.parent?.length)
            buildBreadcrumb(element.node.relationships.parent[0].drupal_internal__tid);

        breadcrumbItems.push({
            name: "Home",
            slug: `/${lang}`,
            active: false
        });

        return breadcrumbItems.reverse();
    } else if (!element && breadcrumbItem) {
        breadcrumbItems.push(...[{
            name: "Home",
            slug: `/${lang}`,
            active: false
        }, breadcrumbItem]);
        return breadcrumbItems;
    }
    return null;
}

export function getTipologiaLink(field_tipologia) {
    return "";
}

export function getAbstract(text, length) {
    length = (typeof length === "number") ? length : 100;
    if (typeof text !== "string")
        return "";
    if (text.length <= length)
        return text;
    const subString = text.substr(0, length - 1);
    return subString.substr(0, subString.lastIndexOf(" ")) + "...";
    return text;
}

export function findRecursive(object, valueToFind, keyToCheck, keyToRecursive) {
    let result = null;
    const searchItem = (item) => {
        if (item && typeof item === "object" && Array.isArray(item[keyToRecursive])) {
            item[keyToRecursive].forEach(subitem => {
                if (subitem[keyToCheck] === valueToFind)
                    result = subitem;
                else searchItem(subitem);
            });
        }
    };
    if (object) {
        if (Array.isArray(object)) {
            object.forEach(item => {
                if (item[keyToCheck] === valueToFind)
                    result = item;
                else searchItem(item);
            });
        } else if (typeof object === "object") {
            if (object[keyToCheck] === valueToFind)
                result = object;
            else searchItem(object);
        }
    }
    return result;
}

export function findParent(fullmenu, drupal_internal__nid) {
    const item = findRecursive(fullmenu, drupal_internal__nid, "idContenuto", "children");
    if (item && item.idParent)
        return findRecursive(fullmenu, item.idParent, "id", "children");
    return item;
}
